import { TwilioVerificationChannelEnum, useTwilioSendCodeMutation } from '@alluradirect/react';

import { Box, Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import styled from 'styled-components';
import { StepperControlsFormik } from 'components/core/navigation/DynamicStepper/components/StepperControlsFormik';
import { AlluraFormikErrorMessage } from 'components/formik/core/AlluraErrorMessage/AlluraFormikErrorMessage';
// import { FormikAppCheckboxWithLabel } from 'components/formik/core/FormikAppCheckboxWithLabel/FormikAppCheckboxWithLabel';
import { SendCodeField } from 'components/views/verification/components/SendCodeField';
import { SendCodeValues } from 'components/views/verification/components/SendCodeFormWrapper';
import { verifyImage } from 'config/imageUrls';
import { useFormikContext } from 'formik';
import { useMemo, ReactNode } from 'react';

export const OptionWrapper = styled(Box)`
  padding: ${props => props.theme.spacing(2)};
  border-radius: 5px;
  background-color: ${props => props.theme.palette.grey[50]};
  border: 1px solid ${props => props.theme.palette.grey[300]};
`;

export const SendCodeForm = ({
  channel,
  handleCloseDialog,
  children,
  isCaptchaValid = false,
}: {
  channel: TwilioVerificationChannelEnum.sms | TwilioVerificationChannelEnum.email;
  handleCloseDialog: () => void;
  children?: ReactNode;
  isCaptchaValid?: boolean;
}) => {
  const { isValid, isSubmitting } = useFormikContext<SendCodeValues>();
  const mutation = useTwilioSendCodeMutation();

  const title = useMemo(() => {
    if (channel === TwilioVerificationChannelEnum.sms) {
      return 'Verify or Update Phone Number';
    } else if (channel === TwilioVerificationChannelEnum.email) {
      return 'Verify or Update Email';
    } else {
      return `Channel: ${channel} not implemented`;
    }
  }, [channel]);

  const description = useMemo(() => {
    if (channel === TwilioVerificationChannelEnum.sms) {
      return 'Please enter your phone number below to update or verify. An SMS text message will be sent to the number with a code to enter on the next screen.';
    } else if (channel === TwilioVerificationChannelEnum.email) {
      return 'Please enter your email below to update or verify. An email will be sent to the email address you entered with a code to enter on the next screen.';
    } else {
      return `Channel: ${channel} not implemented`;
    }
  }, [channel]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <img src={verifyImage} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" color="primary">
          {title}
        </Typography>
        <Typography variant="body2">{description}</Typography>
      </Grid>
      {/* This empty grid element is used for spacing */}
      <Grid item xs={12}></Grid>
      <Grid item xs={12}>
        <SendCodeField channel={channel} />
        <AlluraFormikErrorMessage fieldName={'is_taken'} />
      </Grid>

      {/* This empty grid element is used for spacing */}
      <Grid item xs={12}></Grid>
      {/*
      {channel === TwilioVerificationChannelEnum.sms ? (
        <Grid item xs={12}>
          <OptionWrapper>
            <FormikAppCheckboxWithLabel
              name="is_call"
              label={'If you cannot receive a SMS text, click here to receive the code by a phone call'}
              labelPlacement={'end'}
            />
          </OptionWrapper>
        </Grid>
      ) : null}
*/}
      <Grid item xs={12}>
        {children}
      </Grid>
      <Grid item xs={12}>
        <StepperControlsFormik
          handleBack={handleCloseDialog}
          nextText="Continue"
          backText="Cancel"
          isLoading={mutation.isLoading || isSubmitting}
          isDisabled={mutation.isLoading || !isValid || isSubmitting || !isCaptchaValid}
        />
      </Grid>
    </Grid>
  );
};
